import type { TicketRequestCategoryI } from 'declarations/interfaces/ticketRequestCategories';

import { get } from './api';

export const getTicketRequestCategories = async (
  roofTopId?: string
): Promise<TicketRequestCategoryI[]> => {
  const response = await get<TicketRequestCategoryI[]>('/ticket-request-categories', { roofTopId });

  return response.data;
};
